export default __webpack_public_path__ + "static/media/ProfilSoftware_logo.d4c7298a.svg";